module.exports = __webpack_public_path__ + "static/Short4-e17a24d492aa09736a31689f706a1f99.png";